<template>
    <div class="content">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                breadArray: [
                    {
                        name: this.$t('components.breadcrumb.inference'),
                        path: '/tuili'
                    },
                    {
                        name: this.$t('components.breadcrumb.inferenceTask'),
                        path: ''
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content {
        padding: 20px;
        background-color: #f9f9f9;
    }
</style>